import PropTypes from 'prop-types';
import React from 'react';
import { BsChevronRight } from 'react-icons/bs';
import { RiHome2Line } from 'react-icons/ri';
import styled from 'styled-components';

import devices from '@/utilities/devices';

const BreadcrumbContainer = styled.div`
  width: calc(${props => props.footerContainerWidth}px - 50px);
  display: flex;
  align-items: center;
  margin: 0 auto 1.2em;
  padding: 0em 0em;
  user-select: none;
  .chevron {
    font-size: 1.2em;
    padding: 0 .2em .12em;
  }
  @media screen and (${devices.mobile}) {
    width: 90%;
    margin: -1em auto 1.3em;
    font-size: .85em;
    justify-content: center;
    flex-wrap: wrap;
  }
  @media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
    width: 90%;
    margin: -1em auto 1.3em;
    font-size: .9em;
    justify-content: center;
    flex-wrap: wrap;
  }
`;

const BreadLink = styled.a`
  display: block;
  text-decoration: none;
  color: ${props => props.theme.color.white};
  padding: .4em;
  border-radius: 6px;
  transition: .2s;
  :first-letter {
    text-transform: capitalize;
  }
  :hover {
    opacity: 1;
    background-color: rgba(0, 0, 0, .1);
  }
  svg {
    padding: .4em .1em .1em .1em;
    font-size: 1.2em;
  }
`;

const Breadcrumb = ({ currentPath, footerContainerWidth }) => {
	const breader = () => {

		// current paths divided
		const currentPathList = currentPath?.length > 0 && currentPath.split('/').filter(Boolean);
		const currentLang = currentPathList.shift();
		// array of object with path and text for each chunk of currentPath
		const paths = [];

		for (let i = 0; i < currentPathList?.length; i++) {
			const path = currentPathList[i];
			const href = currentPathList.slice(0, i + 1).join('/');
			// check to remove id mission from breadcrumb
			currentPathList[i - 1] !== 'offre' && (
				paths.push({ text: path.replace(/-/g, ' '), href: `${currentLang}/${href}` })
			);
		}

		if (paths.length > 1) {
			return (
				<>
					<BreadLink href={`/${currentLang}`}> <RiHome2Line /> </BreadLink>
					{paths.map((path, key) =>
						<React.Fragment key={key}>
							<BsChevronRight className='chevron' />
							<BreadLink href={`/${path.href}`}>
								{/* remove params from url text*/}
								{path.text.split('?')[0]}
							</BreadLink>
						</React.Fragment>,
					)}
				</>
			);
		} else if (paths.length === 1) {
			return (
				<>
					<BreadLink href={`/${currentLang}`}> <RiHome2Line /> </BreadLink>
					<BsChevronRight className='chevron' />
					<BreadLink href={`${paths[0].href.replace(`${currentLang}/`, '')}`}> {paths[0].text.split('?')[0]} </BreadLink>
				</>
			);
		} else {
			return;
		}
	};

	return (
		<BreadcrumbContainer footerContainerWidth={footerContainerWidth}>
			{breader()}
		</BreadcrumbContainer>
	);
};

Breadcrumb.propTypes = {
	currentpath: PropTypes.string,
	footerContainerWidth: PropTypes.number,
};

export default Breadcrumb;
